/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { AppointmentService } from './services/appointment.service';

/**
 * Module that provides all services and configuration.
 * Also exports Angular's `HttpClientModule`, as it is required for all services.
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    AuthService,
    UserService,
    AppointmentService,
    ApiConfiguration
  ],
})
export class AppointmentApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders {
    return {
      ngModule: AppointmentApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }
}
